import { http } from "../../utils/config";

const SHINKO_PREFIX = "/api/v1/shinko";

const customerApi = {
  // Duyệt / từ chối tài khoản (trục phê duyệt)
  approve: (customerId, decision = "approve", reason = null) => {
    return http.post(`${SHINKO_PREFIX}/auth/approve`, {
      customer_id: customerId,
      decision,
      reason,
    });
  },

  // Khóa / mở khóa tài khoản đã duyệt (trục khóa)
  toggleLock: (customerId) => {
    return http.post(`${SHINKO_PREFIX}/auth/toggle-lock`, {
      customer_id: customerId,
    });
  },

  uploadImages: (customerId, files, type = "shop") => {
    const formData = new FormData();
    formData.append("customer_id", customerId);
    formData.append("type", type);
    files.forEach((file) => {
      formData.append("images[]", file.originFileObj || file);
    });
    return http.post(`${SHINKO_PREFIX}/customer-images/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  getImages: (customerId, type) => {
    const params = type ? { type } : {};
    return http.get(`${SHINKO_PREFIX}/customer-images/${customerId}`, {
      params,
    });
  },

  deleteImage: (imageId) => {
    return http.delete(`${SHINKO_PREFIX}/customer-images/${imageId}`);
  },

  // Xóa mềm khách hàng (CMS)
  deleteCustomer: (customerId) => {
    return http.delete(`/mcoupon/api/v1/customer/delete/${customerId}`);
  },

  // Khôi phục khách đã xóa mềm (màn Thùng rác). BE trả 422 kèm câu tiếng Việt khi
  // số điện thoại đó đã được tạo tài khoản mới sau lúc xóa.
  restoreCustomer: (customerId) => {
    return http.post(`/mcoupon/api/v1/customer/restore/${customerId}`);
  },
};

const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        throw error.response.data;
      }
      throw new Error(error.message || "Đã có lỗi xảy ra");
    }
  };
};

export const customerApiWithErrorHandling = {
  approve: withErrorHandling(customerApi.approve),
  toggleLock: withErrorHandling(customerApi.toggleLock),
  uploadImages: withErrorHandling(customerApi.uploadImages),
  getImages: withErrorHandling(customerApi.getImages),
  deleteImage: withErrorHandling(customerApi.deleteImage),
  deleteCustomer: withErrorHandling(customerApi.deleteCustomer),
  restoreCustomer: withErrorHandling(customerApi.restoreCustomer),
};

export default customerApi;
